function Transaction({ transaction, hide }) {
    return (
        <div className="ltr-direction w-full " >
            <div className="bg-blue-800 w-full h-6  flex">
                <p className="text-white ms-2 mt-1 text-sm">{transaction.date}</p>
            </div>
            <div className="transaction bg-gray-800 ">
                {/* <ul className=" w-full h-14 flex justify-between items-center  text-center font-semibold text-xl bg-gray-700 ">
               */}
                <ul className=" w-full h-14 grid grid-cols-2 justify-between items-center  text-center font-semibold text-xl bg-gray-800 ">
                    <li className=" flex justify-start text-center font-bold text-xl ">
                        <div
                            className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-semibold me-1 ${transaction.type === 'Commission'
                                ? 'bg-red-500'
                                : transaction.type === 'Church of Lithuania'
                                    ? 'bg-red-800'
                                    : 'bg-yellow-300'
                                }`}
                        >
                            {transaction.type === 'Commission' ? (
                                '%'
                            ) : (transaction.type === 'Church of Lithuania' || transaction.type === 'Support For Ukraine') ? (
                                <img src={
                                    transaction.type === 'Church of Lithuania'
                                        ? './paysera/salib.png'
                                        : './paysera/ukraine.png'
                                } alt="Church" className="w-8 h-8 rounded-full object-cover" />
                            ) : (
                                'Gl'
                            )}
                        </div>

                        <div className="text-sm self-center text-white">
                            {(transaction.type)}
                        </div>
                    </li>
                    <li className={`${transaction.type === 'Google Ireland Limited' ? 'text-green-500 text-lg ' : 'text-red-500 text-lg'} justify-end ml-20 ms-11`}>{(hide ? '*****' : transaction.amount)}</li>
                </ul>
            </div>
        </div >
    );
}
export default Transaction;